import { type Logo, getLogoUseCase, logoLocalRepository } from '~/domains/core';

const useGetLogoAdapter = async (): Promise<Logo | undefined> => {
  return await getLogoUseCase({
    logosRepository: logoLocalRepository,
  });
};

export default useGetLogoAdapter;
